import {
	ErrorType,
	ServerMessage,
	ServerMessageCode,
	TextMessage,
} from '@/constant';

export const getErrorMessageWithTranslation = (errorKey: ServerMessageCode) => {
	return ServerMessageCode[errorKey] ?? 'ALERT_8';
};

export const getErrorMessage = (errorKey: ServerMessageCode) => {
	//@ts-expect-error: ignore here
	const message = ServerMessage[errorKey];

	if (!message) return errorKey ?? TextMessage.ALERT_8;

	return message;
};

export const isErrorType = (value?: string): value is ErrorType => {
	return Object.values(ErrorType).includes(value as ErrorType);
};

export const isEnumValue = <T extends Record<string, string | number>>(
	enumObj: T,
	value?: string | number
): value is T[keyof T] => {
	return Object.values(enumObj).includes(value as T[keyof T]);
};
